import { DataService } from './DataService';
import { toLonLat } from 'ol/proj';
import { mapThemeAttributes } from './DataTransformation';
import { debugMode } from '../model/StaticVariables';

//"ReleaseYear 272018 AND Comparison =national AND GeoLevel=county

const sviFields = ['Overall_SVI_Percentile', 'Theme1_Percentile', 'Theme2_Percentile', 'Theme3_Percentile', 'Theme4_Percentile'];

const themeColumns = {
    general: ['ReleaseYear', 'GeoLevel', 'Comparison', 'ST', 'FIPS', 'E_TOTPOP', 'M_TOTPOP', 'E_HU', 'M_HU', 'E_HH', 'M_HH'],
    theme0: ['*'],
    theme1: ['Theme1_E_POV', 'Theme1_M_POV', 'Theme1_EP_POV', 'Theme1_MP_POV', 'Theme1_EPL_POV', 'Theme1_E_UNEMP', 'Theme1_M_UNEMP', 'Theme1_EP_UNEMP', 'Theme1_MP_UNEMP', 'Theme1_EPL_UNEMP', 'Theme1_E_PCI', 'Theme1_M_PCI', 'Theme1_EP_PCI', 'Theme1_MP_PCI', 'Theme1_EPL_PCI', 'Theme1_E_NOHSDP', 'Theme1_M_NOHSDP', 'Theme1_EP_NOHSDP', 'Theme1_MP_NOHSDP', 'Theme1_EPL_NOHSDP', 'Theme1_SPL', 'Theme1_Percentile'],
    theme2: ['Theme2_E_AGE65', 'Theme2_M_AGE65', 'Theme2_EP_AGE65', 'Theme2_MP_AGE65', 'Theme2_EPL_AGE65', 'Theme2_E_AGE17', 'Theme2_M_AGE17', 'Theme2_EP_AGE17', 'Theme2_MP_AGE17', 'Theme2_EPL_AGE17', 'Theme2_E_DISABL', 'Theme2_M_DISABL', 'Theme2_EP_DISABL', 'Theme2_MP_DISABL', 'Theme2_EPL_DISABL', 'Theme2_E_SNGPNT', 'Theme2_M_SNGPNT', 'Theme2_EP_SNGPNT', 'Theme2_MP_SNGPNT', 'Theme2_EPL_SNGPNT', 'Theme2_SPL', 'Theme2_Percentile'],
    theme3: ['Theme3_E_MINRTY', 'Theme3_M_MINRTY', 'Theme3_EP_MINRTY', 'Theme3_MP_MINRTY', 'Theme3_EPL_MINRTY', 'Theme3_E_LIMENG', 'Theme3_M_LIMENG', 'Theme3_EP_LIMENG', 'Theme3_MP_LIMENG', 'Theme3_EPL_LIMENG', 'Theme3_SPL', 'Theme3_Percentile'],
    theme4: ['Theme4_E_MUNIT', 'Theme4_M_MUNIT', 'Theme4_EP_MUNIT', 'Theme4_MP_MUNIT', 'Theme4_EPL_MUNIT', 'Theme4_E_MOBILE', 'Theme4_M_MOBILE', 'Theme4_EP_MOBILE', 'Theme4_MP_MOBILE', 'Theme4_EPL_MOBILE', 'Theme4_E_CROWD', 'Theme4_M_CROWD', 'Theme4_EP_CROWD', 'Theme4_MP_CROWD', 'Theme4_EPL_CROWD', 'Theme4_E_NOVEH', 'Theme4_M_NOVEH', 'Theme4_EP_NOVEH', 'Theme4_MP_NOVEH', 'Theme4_EPL_NOVEH', 'Theme4_E_GROUPQ', 'Theme4_M_GROUPQ', 'Theme4_EP_GROUPQ', 'Theme4_MP_GROUPQ', 'Theme4_EPL_GROUPQ', 'Theme4_SPL', 'Theme4_Percentile'],
    general_flag: ['F_Total', 'E_UNINSUR', 'M_UNINSUR', 'EP_UNINSUR', 'MP_UNINSUR', 'E_DAYPOP', 'GRASPID'],
    theme0_flag: [],
    theme1_flag: ['F_POV', 'F_UNEMP', 'F_PCI', 'F_NOHSDP', 'F_Theme1'],
    theme2_flag: ['F_AGE65', 'F_AGE17', 'F_DISABL', 'F_SNGPNT', 'F_Theme2'],
    theme3_flag: ['F_MINRTY', 'F_LIMENG', 'F_Theme3'],
    theme4_flag: ['F_MUNIT', 'F_MOBILE', 'F_CROWD', 'F_NOVEH', 'F_GROUPQ', 'F_Theme4']
};
//Quantization params:
// {"mode":"view","originPosition":"upperLeft","tolerance":1.0583354500042335,"extennt":{"type":"extent","xmin":${extent.XMin},"ymin":${extent.YMin},"xmax":${extent.XMax},"ymax":${extent.YMax},"spatialReference":{"wkid":102100,"latestWkid":3857}}}
//&quantizationParameters=%7B%22mode%22%3A%22view%22%2C%22originPosition%22%3A%22upperLeft%22%2C%22tolerance%22%3A1.0583354500042335%2C%22extent%22%3A%7B%22type%22%3A%22extent%22%2C%22xmin%22%3A${extent.XMin}%2C%22ymin%22%3A${extent.YMin}%2C%22xmax%22%3A${extent.XMax}%2C%22ymax%22%3A${extent.YMax}%2C%22spatialReference%22%3A%7B%22wkid%22%3A102100%2C%22latestWkid%22%3A3857%7D%7D%7D
//                        %7B%27extent%27%3A%7B%27type%27%3A%27extent%27%2C%27xmin%27%3A${extent.XMin}%2C%27ymin%27%3A${extent.YMin}%2C%27xmax%27%3A${extent.XMax}%2C%27ymax%27%3A${extent.YMax}%7D%7D/ ' { } :
// quantizationParameters=%7B"extent"%3A%7B"type"%3A"extent"%2C"xmin"%3A${extent.XMin}%2C"ymin"%3A${extent.YMin}%2C"xmax"%3A${extent.XMax}%2C"ymax"%3A${extent.YMax}%7D%7D
class OneMapApiDataService extends DataService {
    _needsAuth = false;
    _name = 'one map';
    constructor() {
        super();

        this._token = this.authenticate();
        this._client.interceptors.response.use(this.responseInterceptor, this.responseError);
        // ** every 8 hrs refresh token, for idle tabs that stay open overnight
        // setInterval(() => {
        //     this._token = this.authenticate();
        // }, 1000 * 60 * 60 * 8);
        // ms     sec  min  hr

        // setInterval(() => {
        //     console.log('refresh auth token....');
        //     this._token = this.authenticate();
        // }, 1000 * 60 * 5);
        // ms     sec  min  hr
    }

    _api = (args) => {
        const { type, theme, scope, tract, year, fips = [], extent = { x1: 0, y1: 0, x2: 0, y2: 0 }, blacklist } = args;
        const state = args.usState || args.state || { id: 0, slug: '', fips: '' };
        // const { type, scope, tract, year, state = { id: 0, slug: "", fips: "" }, extent = { x1: 0, y1: 0, x2: 0, y2: 0 } } = args;
        // const base = 'https://witv-grsp-5.cdc.gov/onemapservices/rest/services/SVI/SVI_consolidated_data/FeatureServer/0/query';
        const base = debugMode ? 'https://wipv-grsp-10.cdc.gov/onemapservices/rest/services/SVI/SVI_consolidated_data/FeatureServer/0/query' : 'https://onemap.cdc.gov/OneMapServices/rest/services/SVI/SVI_consolidated_data/FeatureServer/0/query';
        const graspBase = 'http://grasp_internal_test.cdc.gov/sviwebsite/';
        //                        console.log("Base Info:");
        //                        console.log(base);
        const slug = this.formatSlug(args);
        //Direct access url use for testing:
        //https://wipv-grsp-10.cdc.gov/onemapservices/rest/services
        //grasp 10

        const geometryProps = {
            geometryType: 'esriGeometryPolyline',
            geometryPrecision: 4,
            returnTrueCurve: true
        };
        var themeFields, themeFlags, general;
        const output = { url: '', body: {}, head: {} };
        const defaults = {
            XMin: extent.x1,
            YMin: extent.y1,
            XMax: extent.x2,
            YMax: extent.y2
        };

        switch (slug) {
            case 'geometry_state':
                output.url = 'https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json';
                break;
            // ΔVΔVΔ: Geometry
            case 'geometry_national_county':
            case 'geometry_national_census':
            case 'geometry_state_county':
            case 'geometry_state_census':
                output.url = `${base}`;
                output.body = {
                    where: {
                        ReleaseYear: year,
                        Comparison: scope,
                        GeoLevel: tract == 'census' ? 'tract' : 'county'
                    },
                    f: 'geojson',
                    outfields: ['FIPS'],
                    resultRecordCount: this._record_max
                };
                output.body = { ...output.body, ...geometryProps };

                if (state.fips) {
                    output.body.where.ST = state.fips;
                } else if (fips.length) {
                    output.body.where.fips = fips;
                }
                break;
            case 'table_national_county':
            case 'table_national_census':
            case 'table_state_county':
            case 'table_state_census':
                output.url = `${base}`;
                output.body = {
                    where: {
                        ReleaseYear: year,
                        Comparison: scope,
                        GeoLevel: tract == 'census' ? 'tract' : 'county'
                    },
                    returnGeometry: false,
                    f: 'JSON',
                    outfields: ['GRASPID', 'FIPS', 'ReleaseYear', 'GeoLevel', 'Comparison', 'ST']
                };
                themeFields = themeColumns['theme' + theme.id];
                general = themeColumns['general'];
                if (themeFields[0] === '*') {
                    output.body.outfields = ['*'];
                } else {
                    themeFlags = themeColumns['theme' + theme.id + '_flag'];
                    output.body.outfields.push(...general, ...themeFields);
                    if (themeFlags.length) output.body.outfields.push(...themeFlags);
                }
                if (state.id) {
                    output.body.where.fips = [state.id];
                }
                break;
            // ΔVΔVΔ: SVI data
            case 'svi_national_county':
            case 'svi_national_census':
                output.url = `${base}`;
                output.body = {
                    where: {
                        ReleaseYear: year,
                        Comparison: scope,
                        GeoLevel: tract == 'census' ? 'tract' : 'county'
                    },

                    returnGeometry: false,
                    f: 'JSON',
                    outfields: ['GRASPID', 'FIPS', 'ST', ...sviFields]
                };
                if (fips.length) {
                    output.body.where.fips = fips;
                }
                break;
            case 'svi_state_county':
            case 'svi_state_census':
                output.url = `${base}`;
                output.body = {
                    where: {
                        ReleaseYear: year,
                        Comparison: scope,
                        GeoLevel: tract == 'census' ? 'tract' : 'county'
                    },

                    returnGeometry: false,
                    f: 'JSON',
                    outfields: ['GRASPID', 'FIPS', 'ST', ...sviFields]
                };

                if (fips.length) {
                    output.body.where.fips = fips;
                }

                break;
            case 'geometry_hhs':
                output.url = `${base}`;
                break;

            // ΔVΔVΔ: Lists
            case 'list_county':
                output.url = `${base}/list/allcountieslist.json`;
                break;

            case 'list_state':
                output.url = `${base}/list/statesList.json`;
                break;

            // ΔVΔVΔ: POI
            case 'poi_hospital':
            case 'poi_hospitals':
                // case 'poi_Hospitals':  // Future POI endpoint changes coming in 2023 (US16431)
                output.url = `https://services1.arcgis.com/Hp6G80Pky0om7QvQ/ArcGIS/rest/services/Hospital/FeatureServer/0/query`;
                output.body = {
                    // supportsCoordinatesQuantization: true,
                    // quantizationParameter: { mode: 'view', originPosition: 'upperLeft', tolerance: 1.0583354500042335, extent: { type: 'extent', xmin: ${extent.XMin}, ymin: ${extent.YMin}, xmax: ${extent.XMax}, ymax: ${extent.YMax}, spatialReference: { wkid: 102100, latestWkid: 3857 } } },
                    // quantizationParameter: `{ 'extent': { 'type': 'extent', 'xmin': ${extent.XMin || extent.x1}, 'ymin': ${extent.YMin || extent.y1}, 'xmax': ${extent.XMax || extent.x2}, 'ymax': ${extent.YMax || extent.y2} } }`,
                    geometry: Object.values(extent).join('%2C'),
                    needsAuth: 'false',
                    outfields: 'ID,NAME,ADDRESS,CITY,STATE,COUNTY,ZIP',
                    inSR: '3857',
                    outSR: '3857',
                    f: 'json'
                };
                if (blacklist?.length) output.body.where = `ID+not+in%28${blacklist.join(',')}%29`;
                break;
            case 'poi_nursinghome':
            case 'poi_nursing_home':
            case 'poi_nursing_homes':
                // case 'poi_NursingHomes':  // Future POI endpoint changes coming in 2023 (US16431)
                output.url = `https://services1.arcgis.com/Hp6G80Pky0om7QvQ/ArcGIS/rest/services/NursingHomes/FeatureServer/0/query`;
                output.body = {
                    geometry: Object.values(extent).join('%2C'),
                    needsAuth: 'false',
                    //ΔVΔVΔ: Public school API does not yet have an ID attribute andd breaks lookup
                    // outfields: 'ID,NAME,ADDRESS,CITY,STATE,COUNTY,ZIP',
                    outfields: 'ID,NAME,ADDRESS,CITY,STATE,COUNTY,ZIP',
                    inSR: '3857',
                    outSR: '3857',
                    f: 'json'
                };
                if (blacklist?.length) output.body.where = `ID+not+in%28${blacklist.join(',')}%29`;
                break;

            case 'poi_daycare':
            case 'poi_day_care_centers':
            case 'poi_ChildCareCenters': // Future POI endpoint changes coming in 2023 (US16431)
                //output.url = `https://services1.arcgis.com/Hp6G80Pky0om7QvQ/ArcGIS/rest/services/Child_Care/FeatureServer/0/query`;
                output.url = `https://services1.arcgis.com/Hp6G80Pky0om7QvQ/ArcGIS/rest/services/ChildCareCenter1/FeatureServer/0/query`;
                output.body = {
                    geometry: Object.values(extent).join('%2C'),
                    needsAuth: 'false',
                    outfields: 'ID,NAME,ADDRESS,CITY,STATE,COUNTY,ZIP',
                    inSR: '3857',
                    outSR: '3857',
                    f: 'json'
                };
                if (blacklist?.length) output.body.where = `ID+not+in%28${blacklist.join(',')}%29`;
                break;

            case 'poi_school':
            case 'poi_schools':
            case 'poi_public_schools':
                // case 'poi_Public_Schools':  // Future POI endpoint changes coming in 2023 (US16431) (note, not needed)
                output.url = `https://services1.arcgis.com/Hp6G80Pky0om7QvQ/ArcGIS/rest/services/Public_Schools/FeatureServer/0/query`;
                output.body = {
                    geometry: Object.values(extent).join('%2C'),
                    needsAuth: 'false',
                    outfields: 'OBJECTID,NAME,ADDRESS,CITY,STATE,COUNTY,ZIP',
                    inSR: '3857',
                    outSR: '3857',
                    f: 'json'
                };
                if (blacklist) output.body.where = `OBJECTID+not+in%28${blacklist.join(',')}%29`; //%28 = [ %29 = ]
                break;
            //OBJECTID+not+in[37422]
            //where=OBJECTID+not+in+%2839202%29

            case 'poi_coords_hospital':
            case 'poi_coords_hospitals':
                // case 'poi_Hospitals':  // Future POI endpoint changes coming in 2023 (US16431)
                output.url = `https://services1.arcgis.com/Hp6G80Pky0om7QvQ/ArcGIS/rest/services/Hospital/FeatureServer/0/query`;
                output.body = {
                    // supportsCoordinatesQuantization: true,
                    // quantizationParameter: { mode: 'view', originPosition: 'upperLeft', tolerance: 1.0583354500042335, extent: { type: 'extent', xmin: ${extent.XMin}, ymin: ${extent.YMin}, xmax: ${extent.XMax}, ymax: ${extent.YMax}, spatialReference: { wkid: 102100, latestWkid: 3857 } } },
                    // quantizationParameter: `{ 'extent': { 'type': 'extent', 'xmin': ${extent.XMin || extent.x1}, 'ymin': ${extent.YMin || extent.y1}, 'xmax': ${extent.XMax || extent.x2}, 'ymax': ${extent.YMax || extent.y2} } }`,
                    // geometry: Object.values(extent).join('%2C'),
                    needsAuth: 'false',
                    outfields: 'ID',
                    inSR: '3857',
                    outSR: '3857',
                    f: 'json'
                };
                break;
            case 'poi_coords_nursinghome':
            case 'poi_coords_nursing_home':
            case 'poi_coords_nursing_homes':
                output.url = `https://services1.arcgis.com/Hp6G80Pky0om7QvQ/ArcGIS/rest/services/NursingHomes/FeatureServer/0/query`;
                output.body = {
                    // geometry: Object.values(extent).join('%2C'),
                    needsAuth: 'false',
                    outfields: 'ID',
                    inSR: '3857',
                    outSR: '3857',
                    f: 'json'
                };
                if (state) {
                    output.body.where.STATE = state;
                }
                break;

            case 'poi_coords_daycare':
            case 'poi_coords_day_care_centers':
            case 'poi_coords_ChildCareCenters': // Future POI endpoint changes coming in 2023 (US16431)
                //output.url = `https://services1.arcgis.com/Hp6G80Pky0om7QvQ/ArcGIS/rest/services/Child_Care/FeatureServer/0/query`;
                output.url = `https://services1.arcgis.com/Hp6G80Pky0om7QvQ/ArcGIS/rest/services/ChildCareCenter1/FeatureServer/0/query`;
                output.body = {
                    // geometry: Object.values(extent).join('%2C'),
                    needsAuth: 'false',
                    outfields: 'ID',
                    // outfields: 'ID,NAME,ADDRESS,CITY,STATE,COUNTY,ZIP',
                    inSR: '3857',
                    outSR: '3857',
                    f: 'json'
                };
                break;

            case 'poi_coords_school':
            case 'poi_coords_schools':
            case 'poi_coords_public_schools':
                output.url = `https://services1.arcgis.com/Hp6G80Pky0om7QvQ/ArcGIS/rest/services/Public_Schools/FeatureServer/0/query`;
                output.body = {
                    // geometry: Object.values(extent).join('%2C'),
                    needsAuth: 'false',
                    outfields: 'OBJECTID',
                    inSR: '3857',
                    outSR: '3857',
                    f: 'json'
                };
                break;
            // ΔVΔVΔ: Depreciated: count is an unreliable endpoint
            case 'count':
            case 'count_national_county':
            case 'count_national_census':
            case 'count_state_county':
            case 'count_state_census':
                output.url = `${base}?where=ReleaseYear%3D${year}&returnCountOnly=true&f=pjson`;
                break;
            default:
                var err = new Error('Could Not create call object config for ' + slug);
                throw err;
        }

        if (output.body?.where && typeof output.body.where == 'object') {
            output.body.where = Object.keys(output.body.where)
                .map((key) => {
                    if (key === 'fips' && output.body.where.fips.length) {
                        const fipsSTR =
                            '( ' +
                            output.body.where.fips
                                .map((item) => {
                                    return `FIPS like '${item}%'`;
                                })
                                .join(' or ') +
                            ' )';
                        return fipsSTR;
                    }
                    // return key + "='" + output.body.where[key] + "'";

                    if (key === 'ReleaseYear') {
                        //ΔVΔVΔ: For Integers
                        return key + '=' + output.body.where[key];
                    } else {
                        //ΔVΔVΔ: For strings
                        return key + "='" + output.body.where[key] + "'";
                    }
                })
                .join(' AND ');
            output.body.where = output.body.where.replace(/=/g, '%3D').replace(/ /g, '+').replace(/'/g, '%27');
            output.body.orderByFields = 'FIPS';
        } else if (typeof output.body?.where == 'string') {
            //
        } else {
            output.body.where = '1=1';
        }
        if (output.body?.quantizationParameter) {
            //conveert
            output.body.quantizationParameter = output.body.quantizationParameter.replace(/=/g, '%3D').replace(/ /g, '').replace(/'/g, '%22').replace(/{/g, '%7B').replace(/}/g, '%7D').replace(/:/g, '%3A').replace(/,/g, '%2C');
        }
        // if (output.body.geometry) {
        //     output.body.geometry = output.body.geometry.replace(/,/g, '%2C');
        // }

        return output;
    };
    convertExtent = (extent = [0, 0, 0, 0]) => {
        let ext = toLonLat(extent);
        return String(`xmin=${ext[0]}, ymin=${ext[1]}, xmax=${ext[2]}, ymax=${ext[3]}`).replace(/=/g, '%3D').replace(/ /g, '+').replace(/'/g, '%27').replace(/,/g, '%2C');
    };
    // ΔVΔVΔ: For Reference
    // queryVars = {
    //     request: {
    //         returnCentroid: "center of a feature",
    //         returnCountOnly: "t/f only return result count",
    //         resultOffset: "(start index of request)",
    //         resultRecordCount: "",
    //         outFields: "(sets the fields returned)",
    //         distance: "buffer distance surrounding the suppplied coords",
    //         returnGeometry: "t/f",
    //         recordType: "",
    //         geometryPrecision: "limit decimal point for coords value",
    //         returnExceededLimitFeatures: "=>ignores exceededTransferLimit",
    //         f: "json(format)",
    //         supportsCoordinatesQuantization: "t/f",
    //         quantizationParameters: "",
    //     },
    //     response: {
    //         GRASPID: 134043,
    //         FIPS: "01003011403",
    //         GDB_GEOMATTR_DATA: null,
    //         year: 2018,
    //         ST: "01",
    //         GeoLevel: "(County,Tract)",
    //         Comparison: "(National/State)",
    //         Overall_SVI_Percentile: 0.2102,
    //         Theme1_Percentile: "",
    //         Theme2_Percentile: "",
    //         Theme3_Percentile: "",
    //         Theme4_Percentile: "",
    //     },
    // };
    _batch_max = 150;
    _record_max = 10000;

    getCount = async (args) => {
        const callObj = this.formatCall(args);
        callObj.body.returnCountOnly = true;
        return await this.get(callObj)
            .then((res) => {
                return res.count;
            })
            .catch((err) => {
                return err;
            });
    };

    applyFiltertransformData = (callObj, res) => {
        if (!res || !res.data) return [];
        if (callObj?.args?.type === 'geometry') {
            return [res.data];
        }
        // if (callObj?.args?.type === "svi") {
        //     return [this.convertToSVIobj(res.data)];
        // }
        // if (callObj?.args?.type === "table") {
        //     return res.data.features.map((a) => a.attributes);
        // }
        return res.data ? res.data : [];
    };
    convertToSVIobj2 = (arr) => {
        var obj = {};
        arr.forEach((row) => {
            var item = row.attributes;
            obj[item.FIPS] = mapThemeAttributes(item);
        });
        return obj;
    };
    convertToSVIobj = (arr) => {
        var obj = {};
        arr.features.forEach((row) => {
            var item = row.attributes;
            obj[item.FIPS] = mapThemeAttributes(item);
        });
        return obj;
    };

    // ΔVΔVΔ: Helper function to split array for batch lookups
    _chunkArray = (array, size) => {
        const chunked_arr = [];
        let copied = [...array]; // ES6 destructuring
        const numOfChild = Math.ceil(copied.length / size); // Round up to the nearest integer
        for (let i = 0; i < numOfChild; i++) {
            chunked_arr.push(copied.splice(0, size));
        }
        return chunked_arr;
    };

    getTillEndOfPage = async (props) => {
        let { callProps, callCount = 0, callLimit = 500, batchSize = 2000 } = props;
        // const formatArray = callProps.type === "table";
        var output = []; //formatArray ? [] : {};
        let isLastPage = false;
        let seriesCount = 0;
        const callObject = this.formatCall(callProps);
        while (!isLastPage && callCount < callLimit) {
            const offset = batchSize * seriesCount;
            callObject.body.resultOffset = offset; // / 10;
            callObject.body.resultRecordCount = batchSize; //for test now
            callCount++;
            seriesCount++;
            const json = await this.get(callObject).then((data) => {
                return data?.features || data?.[0]?.features;
                // return formatArray ? data.flat() : data.flat()[0];
            });
            if (!json) return;
            output = [...output, ...json];

            if (json.length < batchSize) {
                isLastPage = true;
            }
        }
        //send a single array of features
        return output;
    };
    validateFips = (fips) => {
        if (fips?.length) return fips;
        if (fips?.size) return Array.from(fips);
        return [0, 1, 2, 3, 4, 5, 6, 7];
    };
    getByPredictedBatch = async (props) => {
        const count = await this.getCount(props);
        const pages = Math.ceil(count / 2000) + 1;
        const pageBatches = Math.ceil(pages / 10);
        const output = [];

        const doTenLookups = async (start, end) => {
            const promises = [];
            for (var i = start; i < end; i++) {
                console.log('Lookup', i);
                const callObject = this.formatCall(props);
                callObject.body.resultOffset = i * 2000;
                callObject.body.resultRecordCount = 2000;

                promises.push(
                    this.get(callObject).then((data) => {
                        console.log('Done   ', data);
                        return data?.features || data?.[0]?.features;
                    })
                );
            }
            return Promise.all(promises).then((res) => {
                return res.flat();
            });
        };
        for (var j = 0; j < pageBatches; j++) {
            var start = j * 10;
            var end = (j + 1) * 10;
            var tenlookups = await doTenLookups(start, Math.min(end, pages));
            output.push(...tenlookups);
        }
        return output;
    };
    getByBatch = async (props) => {
        const { callProps, callLimit = 1000, maximum = 200 } = props;
        const batchSize = 2000;
        let fips = this.validateFips(callProps.fips);
        //ΔVΔVΔ: Make this function more generic, instead of the specific data in th callProps, just pass an array to the fuction
        const chunkedFips = this._chunkArray(fips, 30); //ΔVΔVΔ: looking up more than 59 fips in query seems to create a 404. There seems to be a limitonst chunkedFips = this.chunkArray(props.fips, 50);
        let callCount = 0;
        const promises = [];
        const maxRuns = Math.min(maximum, chunkedFips.length); //create boundary to prevent infinite lookup
        for (var i = 0; i < maxRuns; i++) {
            var aChunkOfCountyFips = chunkedFips[i];
            let propsOnTheFly = Object.assign({}, callProps, {
                fips: aChunkOfCountyFips
            });
            promises.push(
                this.getTillEndOfPage({
                    callProps: propsOnTheFly,
                    callCount,
                    callLimit,
                    batchSize
                }).then((res) => {
                    return res;
                })
            );
        }

        return await Promise.all(promises).then((res) => {
            return res.flat();
        });
    };
    getFirstPageTableData = async (props) => {
        props.type = 'table';
        const config = this.formatCall(props);
        config.body.resultRecordCount = 100;
        return await this.get(config).then((res) => {
            const tableDat = res.features.map((a) => a.attributes);
            return tableDat;
        });
    };
    getTableData = async (props) => {
        props.type = 'table';
        return await this.getByPredictedBatch(props).then((res) => {
            const tableDat = res.map((a) => a.attributes);
            return tableDat;
        });
        // return await this.getByBatch({
        //     callProps: props
        // }).then((res) => {
        //     //return res.data.features.map((a) => a.attributes);
        //     const tableDat = res.map((a) => a.attributes);
        //     return tableDat;
        //     // return allFipsAllPagesData;
        // });
    };
    // getSVIData => break fips array into batches/chunks. For each chunk call the api until the endpoint indicates that there are no more records to return
    getSVIData = async (props) => {
        props.type = 'svi';
        return await this.getByBatch({
            callProps: props
        }).then((res) => {
            const sviObject = this.convertToSVIobj2(res);
            return sviObject;
        });
    };
    // geo data by state
    getGeometryData = async (props) => {
        props.type = 'geometry';
        var allFipsAllPagesData = [];
        await this.getTillEndOfPage({ callProps: props }).then((res) => {
            allFipsAllPagesData.push(res);
        });

        return allFipsAllPagesData.flat();
    };
    getPOIData = async (props) => {
        const { scope, extent, year, tileKey, blacklist } = props;
        var allPOIpageData = await this.getTillEndOfPage({
            callProps: { type: 'poi', scope, extent, year, tileKey, blacklist }
        });

        return allPOIpageData;
    };
    getPOICoords = async (props) => {
        const { scope, extent } = props;
        var allPOIpageData = await this.getTillEndOfPage({
            callProps: { type: 'poi_coords', scope, extent }
        });

        return allPOIpageData;
    };

    // ΔVΔVΔ: !!!Temporary solution, should keep pw info serverside
    getAuthCall = () => {
        const un = 'svi_interactive_map';

        const pw = encodeURIComponent('qrx.ujz.VND7cjp2cdc');
        var h = encodeURIComponent(window.location.origin);
        h = h ? h : 'http://localhost'; //fallback for local testin

        return {
            args: { type: 'auth' },
            url: 'https://onemap.cdc.gov/Portal/sharing/rest/generateToken',
            body: `username=${un}&password=${pw}&referer=${h}&expiration=60&f=json`,
            head: { 'Content-Type': 'application/x-www-form-urlencoded' }
        };
    };
}
export { OneMapApiDataService };

// https://onemap.cdc.gov/OneMapServices/rest/services/SVI/SVI_consolidated_data/FeatureServer/0/query?where=ReleaseYear%3D%272000%27+AND+Comparison%3D%27national%27+AND+GeoLevel%3D%27tract%27&returnGeometry=false&f=JSON&outfields=GRASPID,FIPS,ST,Overall_SVI_Percentile,Theme1_Percentile,Theme2_Percentile,Theme3_Percentile,Theme4_Percentile&orderByFields=FIPS&resultOffset=0&resultRecordCount=2000
